"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.NotesNavbarv2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ui_common_1 = require("@codametrix/ui-common");
var classnames_1 = __importDefault(require("classnames"));
var conditional_1 = require("../conditional/conditional");
var svg_icons_1 = require("../svgs/svg-icons");
var DEFAULT_PROPS = {
    documentMetadata: [],
    grouped: false,
    onSelect: function (docMetadata) { }
};
var DocCategories = {
    DFT: 'DFTs',
    DFT_IN: 'Inbound DFTs',
    DFT_OUT: 'Outbound DFTs',
    NTE: 'Notes',
    NOTE: 'Notes',
    HL7: 'HL7 Messages',
    DFT_EHR: 'DFT EHRs'
};
var NotesNavbarv2 = function (passed) {
    var props = __assign(__assign({}, DEFAULT_PROPS), passed);
    var documentMetadata = props.documentMetadata, onSelect = props.onSelect, activeNote = props.activeNote, isIPC = props.isIPC, capabilities = props.capabilities, grouped = props.grouped, showAddAttachDocsButton = props.showAddAttachDocsButton, showAttachDocsModal = props.showAttachDocsModal;
    var _a = __read((0, react_1.useState)(0), 2), currentIndex = _a[0], setCurrentIndex = _a[1];
    var documentsPerPage = 5; // Number of documents to show per page
    //@ts-ignore
    var prepped = (documentMetadata || []).map(function (doc) {
        if (doc.mimeType === 'text/html') {
            doc.documentCategory = 'HTML';
        }
        return __assign(__assign({}, doc), { documentCategory: DocCategories[doc.documentCategory] || doc.documentCategory });
    });
    var preppedDocs;
    if (grouped) {
        var sortGroupedDocs = function (a, b) {
            if (a === b)
                return 0;
            if (a === 'HL7 Messages' || a === 'Notes')
                return -1;
            if (b === 'HL7 Messages' || b === 'Notes')
                return 1;
            if (a < b)
                return -1;
            if (a > b)
                return 1;
            return 0;
        };
        preppedDocs = ui_common_1.objectUtils.groupBy(prepped, 'documentCategory');
        Object.keys(preppedDocs).sort(sortGroupedDocs);
    }
    else {
        preppedDocs = prepped;
    }
    var buildDocList = function (docs) {
        return docs.map(function (document, idx) {
            var _a;
            var onClick = function (event) {
                event.preventDefault();
                onSelect(document);
            };
            var isActive = (activeNote === null || activeNote === void 0 ? void 0 : activeNote.id) === document.id;
            var styleClasses = (0, classnames_1["default"])([
                { 'is-active': isActive },
                'navbar-link'
            ]);
            return ((0, jsx_runtime_1.jsx)("li", __assign({ className: styleClasses }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: "#/something", onClick: onClick, className: "document-list-item" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "document-name" }, { children: (_a = document.documentName) !== null && _a !== void 0 ? _a : 'Name N/A' })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "document-description" }, { children: document.documentDescription })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "document-status" }, { children: document.documentStatus }))] })) }), document.documentGuid.uuid));
        });
    };
    var displayDocs = function (docs) {
        var startIndex = currentIndex * documentsPerPage;
        var endIndex = startIndex + documentsPerPage;
        return docs.slice(startIndex, endIndex);
    };
    var handlePrevClick = function () {
        setCurrentIndex(function (prev) { return Math.max(prev - 1, 0); });
    };
    var handleNextClick = function () {
        var maxIndex = Math.ceil(preppedDocs.length / documentsPerPage) - 1;
        setCurrentIndex(function (prev) { return Math.min(prev + 1, maxIndex); });
    };
    var content;
    if (grouped) {
        content = Object.keys(preppedDocs).map(function (key) {
            var docs = preppedDocs[key];
            var items = buildDocList(displayDocs(docs));
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "note-doc-category", style: { display: 'none' } }, { children: docs[0].documentCategory })), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "note-navbar-list" }, { children: items }))] }, key));
        });
    }
    else {
        var listClass = (0, classnames_1["default"])('note-navbar-list', {
            'justify-flex-start': displayDocs(preppedDocs).length < documentsPerPage
        });
        content = ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("ul", __assign({ className: listClass }, { children: buildDocList(displayDocs(preppedDocs)) })) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "notes-navbar" }, { children: [documentMetadata && documentMetadata.length > documentsPerPage && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "navigation" }, { children: [currentIndex > 0 && ((0, jsx_runtime_1.jsx)("button", __assign({ className: "nav-left", onClick: handlePrevClick }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeLeftArrow", svgIconSize: "20" }) }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: "content-container" }, { children: content })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: showAddAttachDocsButton }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ className: "add-button", onClick: showAttachDocsModal }, { children: [(0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomePlusCircle", svgIconSize: "20" }), "Add"] })) })), currentIndex <
                        Math.ceil(preppedDocs.length / documentsPerPage) - 1 && ((0, jsx_runtime_1.jsx)("button", __assign({ className: "nav-right", onClick: handleNextClick }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeRightArrow", svgIconSize: "20" }) })))] }))), !(documentMetadata && documentMetadata.length > documentsPerPage) && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "navigation" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "content-container" }, { children: content })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: showAddAttachDocsButton }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ className: "add-button", onClick: props.showAttachDocsModal }, { children: [(0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomePlusCircle", svgIconSize: "20" }), "Add"] })) }))] }))), props.children] })));
};
exports.NotesNavbarv2 = NotesNavbarv2;
//# sourceMappingURL=notes-navbarv2.js.map